export default __webpack_public_path__ + "static/homepage-selection-f1cc56b92acdc4f6ff2d9b2251b3d721.jpg";